import { CenterHeaderComponentStackProvider } from '@perpay-web/fintech/hooks/useCenterHeaderContext';
import { FullHeaderComponentStackProvider } from '@perpay-web/fintech/hooks/useFullHeaderContext';
import { HeaderLeftNavComponentStackProvider } from '@perpay-web/fintech/hooks/useHeaderLeftNavContext';
import { HeaderRightNavComponentStackProvider } from '@perpay-web/fintech/hooks/useHeaderRightNavContext';
import { TransparentHeaderProvider } from '@perpay-web/fintech/hooks/useHeaderTrasparentContext';
import { FullBottomNavComponentStackProvider } from '@perpay-web/hooks/useFullBottomNavContext';
import { createCombinedProvider } from '@perpay-web/utils/componentUtils';

const ComponentStackProviders = createCombinedProvider(
    CenterHeaderComponentStackProvider,
    FullBottomNavComponentStackProvider,
    FullHeaderComponentStackProvider,
    HeaderRightNavComponentStackProvider,
    HeaderLeftNavComponentStackProvider,
    TransparentHeaderProvider,
);

export default ComponentStackProviders;
